import type { Components, Theme } from "@mui/material/styles";

// The picker's accessible-DOM structure (v8 default) renders an outer
// `PickersTextField` (a FormControl wrapper) around the `PickersOutlinedInput`.
// Both elements pick up `.Mui-focused` when a date section is focused. The
// focus ring belongs on the input itself (see MuiPickersOutlinedInput),
// matching how MuiOutlinedInput is wired for TextField — so we clear any
// default focus styling on the outer wrapper to avoid a double ring.
export const MuiPickersTextField: NonNullable<
  Components<Theme>["MuiPickersTextField"]
> = {
  styleOverrides: {
    root: {
      "&.Mui-focused": {
        boxShadow: "none",
      },
    },
  },
};
